import { triggerFileDownload } from "./triggerFileDownload"

const downloadFile = (data: string[], filename: string, type = "text/csv") => {
  const blob = new Blob(data, { type })

  triggerFileDownload(blob, filename)
}

export default downloadFile
